import React from "react";
import styles from "./styles.module.scss";
export interface ISupportItem {
  icon: React.ReactElement;
  heading: string;
  id: string;
  onClick?: () => void;
}

export const SupportItem: FC<ISupportItem> = ({
  icon,
  heading,
  id,
  onClick,
}) => {
  return (
    <div className={styles.supportItem} data-test-id={id} onClick={onClick}>
      {icon}
      <p>{heading}</p>
    </div>
  );
};
